/* Cost calculator for /pages/calculator.

   Deliberately does NOT tell anyone how long a bottle will last. That figure
   depends on how much a household cleans and how heavy their pour is, neither of
   which we can see, and getting it wrong turns a selling point into a complaint.
   In practice most people do not measure and dilute heavier than directed, so a
   duration promise is the one number on this page that would routinely be wrong.

   Cost per made up litre is the honest version of the same argument, and it
   survives the sloppiest pour on the page: a generous glug still lands near a
   dollar against four to seven on the shelf.

   Prices come from a Liquid island built off the live products, so the tool
   cannot quote a price the store no longer charges. */
(function () {
  var root = document.getElementById("calc");
  if (!root) return;

  var PACKS = (window.HK_PACKS && window.HK_PACKS.length === 3)
    ? window.HK_PACKS
    : [{ litres: 1, price: 39.99 }, { litres: 2, price: 70 }, { litres: 3, price: 99 }];

  /* Millilitres of concentrate per made up litre. 10ml is the directed everyday
     dose printed on the bottle; the other two are what pouring by eye actually
     looks like, rounded generously against ourselves. */
  var DOSE = { 1: 10, 2: 15, 3: 25 };
  var DOSE_LABEL = {
    1: "Measuring a capful, about 10ml to a litre",
    2: "A rough splash, call it 15ml to a litre",
    3: "A generous glug, call it 25ml to a litre",
  };

  var SHELF_LOW = 4, SHELF_HIGH = 7;
  var state = { pack: "1", dose: "1" };

  var els = {
    cost: document.getElementById("calcCost"),
    bottles: document.getElementById("calcBottles"),
    saved: document.getElementById("calcSaved"),
    note: document.getElementById("calcNote"),
  };

  var whole = function (n) { return "$" + n.toLocaleString("en-AU", { maximumFractionDigits: 0 }); };
  var exact = function (n) { return "$" + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2)); };
  /* Under a dollar reads better in cents, which is also how the rest of the site
     talks about it ("about 40c each"). */
  var perBottle = function (n) {
    /* Round to cents BEFORE choosing the unit. Testing n < 1 first rendered
       $0.99975 as "100c", because it is under a dollar right up until it is
       rounded, and "100c" is not how anyone writes a dollar. */
    var c = Math.round(n * 100);
    return c < 100 ? c + "c" : "$" + (c / 100).toFixed(2);
  };

  function render() {
    var pack = PACKS[Number(state.pack) - 1] || PACKS[0];
    var ml = DOSE[state.dose];
    var bottlesPerLitre = 1000 / ml;
    var bottles = Math.round(pack.litres * bottlesPerLitre);
    var cost = pack.price / bottles;

    els.cost.textContent = perBottle(cost);
    els.bottles.textContent = String(bottles);
    els.saved.textContent = whole(bottles * SHELF_LOW) + " to " + whole(bottles * SHELF_HIGH);

    els.note.textContent =
      DOSE_LABEL[state.dose] + ", " + pack.litres + (pack.litres === 1 ? " litre" : " litres") +
      " at " + exact(pack.price) + " makes about " + bottles + " made up bottles at " +
      perBottle(cost) + " each. The same " + bottles + " bottles bought ready to use would be " +
      whole(bottles * SHELF_LOW) + " to " + whole(bottles * SHELF_HIGH) + ". " +
      "How long that lasts is up to how much you clean, so we do not guess at it.";
  }

  /* The options are single select but shipped as buttons carrying aria-pressed,
     which announces "pressed" rather than a choice out of three. Upgraded here to
     a real radiogroup with roving tabindex and arrow key support. */
  Array.prototype.forEach.call(root.querySelectorAll(".calc-opts"), function (group) {
    group.setAttribute("role", "radiogroup");
    var opts = Array.prototype.slice.call(group.querySelectorAll(".calc-opt"));

    function select(btn, focus) {
      state[btn.getAttribute("data-g")] = btn.getAttribute("data-v");
      opts.forEach(function (o) {
        var on = o === btn;
        o.setAttribute("aria-checked", on ? "true" : "false");
        o.tabIndex = on ? 0 : -1;
        o.classList.toggle("is-on", on);
      });
      if (focus) btn.focus();
      render();
    }

    opts.forEach(function (btn, i) {
      btn.setAttribute("role", "radio");
      var pressed = btn.getAttribute("aria-pressed") === "true";
      btn.setAttribute("aria-checked", pressed ? "true" : "false");
      btn.removeAttribute("aria-pressed");
      btn.tabIndex = pressed ? 0 : -1;
      if (pressed) { state[btn.getAttribute("data-g")] = btn.getAttribute("data-v"); btn.classList.add("is-on"); }

      btn.addEventListener("click", function () { select(btn, false); });
      btn.addEventListener("keydown", function (e) {
        var next = null;
        if (e.key === "ArrowRight" || e.key === "ArrowDown") next = opts[(i + 1) % opts.length];
        else if (e.key === "ArrowLeft" || e.key === "ArrowUp") next = opts[(i - 1 + opts.length) % opts.length];
        else if (e.key === " " || e.key === "Enter") next = btn;
        if (!next) return;
        e.preventDefault();
        select(next, true);
      });
    });
  });

  render();
})();
